import React from "react";
import ReCAPTCHA from "react-google-recaptcha";
import css from "./ReCapcha.module.css";

const capchaSiteKey = process.env.REACT_APP_GOOGLE_RECAPTCHA_SITE_KEY;

const ReCapcha = (props) => {
  const { setCapchaChecked } = props;

  function onChange(value) {
    setCapchaChecked(true);
  }

  if (!capchaSiteKey) {
    return (
      <p>
        Missing capcha api key. You can get them from{" "}
        <a href="http://www.google.com/recaptcha/admin">here.</a>
      </p>
    );
  }
  return (
    <div className={css.wrapper}>
      <ReCAPTCHA sitekey={capchaSiteKey} onChange={onChange} />
    </div>
  );
};

export default ReCapcha;
